import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const anatomicSiteService = {
  getAnatomicSites() {
    return viperApi.get(`${clinicalApiPath}/anatomic-sites`)
  }
}
